export const Url = "https://lend-me-token.developer-ourbase-camp.com/api/";
export const SitesettingEndpoint = "site-settings";
export const FaqEndpoint = "faqs";
export const AboutEndpoint = "about-us";
export const PartnerEndpoint = "partner";
export const NewsletterEndpoint = "news-letter";
export const FeatureEndpoint = "feature";
export const NftTypeEndpoint = "nft-type";
export const NftsEndpoint = "nft";
export const ContactEndpoint = "contact-query";
export const SocialEndpoint = "social-link";
export const ImagesEndpoint = "image";
export const RoadMapEndpoint = "roadmap";
export const CommunityEndpoint = "community";
export const CommunityFaqEndpoint = "community_faqs";
